import { atomWithStorage } from "jotai/utils";

export type Currency = "USD" | "EUR";

export const USD_TO_EUR = 0.92;

const EUROZONE_REGIONS = new Set([
	"AT",
	"BE",
	"CY",
	"EE",
	"FI",
	"FR",
	"DE",
	"GR",
	"IE",
	"IT",
	"LV",
	"LT",
	"LU",
	"MT",
	"NL",
	"PT",
	"SK",
	"SI",
	"ES",
]);

export function detectDefaultCurrency(): Currency {
	if (typeof navigator === "undefined") return "USD";
	try {
		const locale = new Intl.Locale(navigator.language);
		const region = locale.region ?? locale.maximize().region;
		if (region && EUROZONE_REGIONS.has(region)) return "EUR";
	} catch {
		// ignore
	}
	return "USD";
}

const rawCurrencyStorage = {
	getItem: (key: string, initialValue: Currency): Currency => {
		if (typeof window === "undefined") return initialValue;
		const val = localStorage.getItem(key);
		if (!val) return initialValue;
		if (val === "USD" || val === "EUR") return val;
		// Migrate legacy double-encoded value (e.g. '"USD"')
		try {
			const parsed: unknown = JSON.parse(val);
			if (parsed === "USD" || parsed === "EUR") return parsed;
		} catch {}
		return initialValue;
	},
	setItem: (key: string, value: Currency) => {
		localStorage.setItem(key, value);
	},
	removeItem: (key: string) => {
		localStorage.removeItem(key);
	},
};

export const currencyAtom = atomWithStorage<Currency>(
	"currency-preference",
	"USD",
	rawCurrencyStorage,
);
